import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { CurrencyValue }  from '@jutro/components'
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { CancellationService } from 'gw-capability-gateway';
import { MLModalService } from 'ml-portals-services-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLTagManagerService } from 'ml-portals-services-react';
import appConfig from 'app-config';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';

import { Identify  } from "gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent";
import metadata from './MLSubmitCancellationPage.metadata.json5';
import messages from './MLSubmitCancellationPage.messages';
import styles from './MLSubmitCancellationPage.module.scss'

function MLSubmitCancellationPage(props) {
    const {
        updateWizardData, wizardData, goNext
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const isGPA = appConfig.portalCode === 'GPA';
    const isModernProduct = submissionVM.policy?.latestPeriod?.isModernProduct_Ext?.value;

    const ModalService = MLModalService();
    const AlertService = MLNotificationBlockUtil();

    useEffect(() => {
        Identify('Cancellation Step Reached', {step: 'Submit Cancellation Screen'}, submissionVM, authHeader)        
    }, [])
    
    useEffect(()=> {
        if (submissionVM.isUnbundling_ML.value) {
            const warningMessage = (
                <p>
                    {translator(messages.warningMessage1, {strong: (chunks) => <strong>{chunks}</strong>})}
                    <br />
                    {isModernProduct? translator(messages.warningMessage2ForNP, {strong: (chunks) => <strong>{chunks}</strong>}) : translator(messages.warningMessage2, {strong: (chunks) => <strong>{chunks}</strong>})}
                </p>
            );
            AlertService.addWarningAlert(warningMessage, 'cancellingWillUnbundlePolicy');
        }else{
            AlertService.addWarningAlert(messages.warningMessage1, 'cancellationWillImpactPremium');
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Cancel Step Reached', false, submissionVM, authHeader, { step: 'PolChange Submit Cancellation Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getChangeInCostDisplay = useCallback(() => {
        const copyChange = {...submissionVM.changeInCost.value};
        copyChange.amount = Math.abs(copyChange.amount);
        return <CurrencyValue value={copyChange} />
    }, [submissionVM.changeInCost.value]);

    const onNext = useCallback(() => {
        const model = submissionVM.value;
        const promise = CancellationService.bindCancellation(model.jobNumber, authHeader).then((result) => {
            MLTagManagerService.sendFormStepCancellationStep(result);
            submissionVM.value = result;
            updateWizardData(wizardData);

            if (isGPA) {
                PolChangeTrackEvent('Cancel Step Submitted', false, submissionVM, authHeader, {
                    step: 'PolChange Submit Cancellation Screen',
                    action: 'Cancellation Submitted'
                });
            }

            goNext();

        });
        promise.catch((error) => {
            error.modalTitle = translator(messages.bindErrorTitle);
            error.modalMessage =  translator(messages.bindErrorMessage);
            throw error;
        });

        ModalService.showProgressDialog(messages.cancelling, promise);
    }, [ModalService, authHeader, goNext, submissionVM, translator, updateWizardData, wizardData]);

    const getPriceColumnHeader = useCallback(() => {
        const price = _.get(submissionVM, 'changeInCost.value.amount', 0);
        if(price <= 0){
            return <strong>{translator(messages.refundDue)}</strong>
        }
        return <strong>{translator(messages.amountDue)}</strong>
    }, [submissionVM, translator]);

    const getNextStepText = useCallback(() => {
        return (
            <>
                {translator(messages.nextDescription, {
                    strong: (chunks) => <strong>{chunks}</strong>
                })}
            </>
        );
    }, [translator]);;

    const overrideProps = {
        nextDescription: {
            content: getNextStepText(),
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext,
            getChangeInCostDisplay,
            getPriceColumnHeader
        }
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                
            />
        </WizardPage>
    );
}

export default MLSubmitCancellationPage;